import React, {
  Component
} from 'react';
const $=window.$;

export default class ManagementTeam extends Component {
 componentDidMount() {
   setTimeout(()=>{

    // Team Carousel
    var owl = $('#team-carousel');
    owl.owlCarousel({
     goToFirstSpeed :2500,
     loop:true,
     autoplay:true,
     autoplayTimeout:2000,
     autoplayHoverPause:true,
        responsive: {
      0:{ items:1 },
      500:{ items:2 },
      768:{ items:3 },
      1024:{ items:4 }
     },
      nav : true,
      dots : false,
    });

   },100);
 }
  render() {
    return (
     <section className="manage-team">
       <div className="row">
         <h2>Management Team</h2>
         <span className="line2"></span>
         <p>Our leadership team has deep, rich and varied experience in different areas including academics, corporate leadership and strategic communication</p>
         <div id="team-carousel" className="owl-carousel owl-loaded">
           <div className="item"><img src="images/gopi.jpg" alt=""/>
             <div className="team-detail">
               <h2>GOPI</h2>
               <p>The Integrator</p>
             </div>
           </div>
           <div className="item"><img src={process.env.PUBLIC_URL +'/images/ram.jpg'} alt=""/>
             <div className="team-detail">
               <h2>Ram</h2>
               <p>The Business Mind</p>
             </div>
           </div>
           <div className="item"><img src={process.env.PUBLIC_URL +'/images/ritu.jpg'} alt=""/>
             <div className="team-detail">
               <h2>Ritu</h2>
               <p>The Creator</p>
             </div>
           </div>
           <div className="item"><img src={process.env.PUBLIC_URL +'/images/terence.jpg'} alt=""/>
             <div className="team-detail">
               <h2>Terence</h2>
               <p>The Organization Man</p>
             </div>
           </div>
           <div className="item"><img src={process.env.PUBLIC_URL +'/images/sai.jpg'} alt=""/>
             <div className="team-detail">
               <h2>Sai Sumanth B</h2>
               <p>Head – Enterprise Business</p>
             </div>
           </div>
           <div className="item"><img src={process.env.PUBLIC_URL +'/images/krc.jpg'} alt=""/>
             <div className="team-detail">
               <h2>Krish Ramachandran</h2>
               <p>Chief Strategy Officer</p>
             </div>
           </div>
           <div className="item"><img src={process.env.PUBLIC_URL +'/images/suresh.jpg'} alt=""/>
             <div className="team-detail">
               <h2>Suresh K</h2>
               <p>Head – CoE – Big Data and Analytics</p>
             </div>
           </div>
           <div className="item"><img src={process.env.PUBLIC_URL +'/images/jayan.jpg'} alt=""/>
             <div className="team-detail">
               <h2>Jayan N</h2>
               <p>Chief Marketing Officer</p>
             </div>
           </div>
           <div className="item"><img src={process.env.PUBLIC_URL +'/images/viswanathan.jpg'} alt=""/>
             <div className="team-detail">
               <h2>Viswanathan E</h2>
               <p>Head – Channels</p>
             </div>
           </div>
         </div>
       </div>
     </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/partials/ManagementTeam.js